export const ROUTES = {
    HOME: "/",
    YEAR: "/:year",
    LOGIN: "/login",
    FORGOTTEN_PASSWORD: "/forgotten-password",
    COMPLETE_SIGN_UP: "/complete-sign-up/:userId",
    LECTURE: "/lecture/:id",
    UPLOAD: "/upload",
    AUTH_VIMEO_CALLBACK: '/auth/vimeo/callback',
  };
  